import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import FileAppResource from './FileAppResource';
import LandingPageAppResource from './LandingPageAppResource';
import LandingPageHomeSectionAppResource from './LandingPageHomeSectionAppResource';

class LandingPageHomeLoanOfficerAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'landing-page-home-loan-officer';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'landings/pages/homes/loans/officers';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'landingPageUuid',
            'homeSectionUuid',
            'avatarFileUuid',
            'firstName',
            'lastName',
            'email',
            'organizationName',
            'organizationLogoUuid',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            landingPage: LandingPageAppResource,
            landingPageHome: LandingPageHomeSectionAppResource,
            avatar: FileAppResource,
            organizationLogo: FileAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            landingPage: 'landing_page_uuid',
            landingPageHome: 'home_section_uuid',
            avatar: 'avatar_file_uuid',
            organizationLogo: 'organization_logo_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        let rules = {
            landingPageUuid: {
                type: 'string',
            },
            homeSectionUuid: {
                type: 'string',
            },
            avatarFileUuid: {
                type: 'string',
            },
            organizationLogoUuid: {
                type: 'string',
            },
            firstName: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                    tooShort: 'is required!',
                }
            },
            lastName: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                    tooShort: 'is required!',
                }
            },
            email: {
                type: 'string',
                length: {
                    maximum: 255
                }
            },
            organizationName: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                    tooShort: 'is required!',
                }
            },
        };
        return rules;
    }

}

export default LandingPageHomeLoanOfficerAppResource;
